const DisclaimerText = "This website is the GenesisAI Marketplace Beta. Some of the content," +
    " including company names and services offered, was manufactured and" +
    " curated for illustrative properties. Functionality of the Beta" +
    " represents the preliminary functionality of the marketplace, which" +
    " will improve and change as our company develops more advanced" +
    " features. The current platform will not accept payment for services or" +
    " allow users to offer services, as it is not a fully-functional" +
    " marketplace yet.";

export default DisclaimerText;


// WEBPACK FOOTER //
// ./src/components/model/Disclaimer/DisclaimerText.tsx